module.exports = __webpack_public_path__ + "static/images/skinbtn2.81b1d0c.png";